// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"scroll-style-outerContainer__3Gcmz","innerContainer":"scroll-style-innerContainer__3-SYH","heightAuto":"scroll-style-heightAuto__1j8ou"};